import {
    useLocalStorage,
    decrypted_key,
    SkillIDsRev,
    CURRENT_SEASON,
    missing_season_items,
    getElemFromProp,
    seed_is_initalised,
} from "../../Utils"
import Control from "./Gacha/Control"
import React, { useState, useCallback } from "react"
import ResultSet from "./Gacha/Result"
import XORSHIFT128 from "./RNGLib"
import LotReward from "../../assets/json/parameters/LotRewardData.json"
import classes from "./SeedLister.module.css"
import GachaInit from "./Gacha/GachaInit"
import ControlInit from "./Gacha/ControlInit"
import ResultInit from "./Gacha/ResultInit"
import { defaultImportData, defaultProfile } from "../../DefaultEntries"
import { get_reward_types } from "../../Utils"
import { useTranslation } from "react-i18next"
import { add_byname, add_nameplate } from "./Util/ProfileHandler"
import { TempProfile } from "./Util/TempProfile"
import { NamePlateBG } from "../NamePlateBg/NamePlateBg"
import { BynameAdjectiveString, BynameSubjectString } from "../Byname/Byname"

export const format_grade = entry => {
    return (
        <div className={classes.container}>
            <img
                className={classes.upper}
                src={`https://leanny.github.io/splat3/images/capsules/LobbyCapsule_Top_0${entry.Grade}.png`}
                alt={entry.Grade}
            />
            <img
                className={classes.lower}
                src={`https://leanny.github.io/splat3/images/capsules/LobbyCapsule_Bottom_0${entry.Grade}.png`}
                alt={entry.Grade}
            />
        </div>
    )
}

const Gacha = props => {
    const [userData, setUserData] = useLocalStorage("importData", defaultImportData)
    const [profile, setProfileData] = useLocalStorage("profile", defaultProfile)

    const is_setup_accuracy_mode = () => {
        return (
            userData.CloudRandomSet !== undefined &&
            userData.CloudRandomSet.Map[props.localKey].Context1 > 0 &&
            userData.CloudRandomSet.Map["RewardRandomPool_Byname"].Context1 > 0 &&
            userData.CloudRandomSet.Map["RewardRandomPool_NamePlateBg"].Context1 > 0 &&
            (profile.BynameAdjectiveMap[3000] ?? false) &&
            (profile.BynameSubjectMap[3000] ?? false) &&
            (profile.NamePlateBgMap[1] ?? false)
        )
    }
    const [accuracyMode, setAccuracyMode] = useState(is_setup_accuracy_mode())
    const [changed, setChanged] = useState(false)
    const { t } = useTranslation()
    const reward_types = get_reward_types(t)

    const to_hex = x => `0x${(x >>> 0).toString(16)}`

    const init_current_seed = () => {
        if (userData.CloudRandomSet === undefined) {
            const rng = new XORSHIFT128(`${decrypted_key()}_${props.localKey}`)
            return rng.get_state()
        }
        const inital_seed = userData.CloudRandomSet.Map[props.localKey]
        return [to_hex(inital_seed.Context1), to_hex(inital_seed.Context2), to_hex(inital_seed.Context3), to_hex(inital_seed.Context4)]
    }

    const [currentSeed, setCurrentSeed] = useState(init_current_seed())
    const [currentStartFrame, setCurrentStartFrame] = useState(1)
    const [currentNumberOfFrames, setCurrentNumberOfFrames] = useState(10)
    const [displayResults, setDisplayResults] = useState([])
    const [selectedResultTypes, setSelectedResultTypes] = useState(reward_types)
    const [possibleResults, setPossibleResults] = useState([])

    const initialised = seed_is_initalised(userData, props.localKey)

    const handleResultTypes = e => {
        setSelectedResultTypes(e)
    }

    const checkSeedHandler = (event, idx) => {
        let inputstr = event.target.value.toUpperCase()
        if (inputstr.substring(0, 2) === "0X") {
            inputstr = inputstr.substring(2)
        }
        inputstr = inputstr.replace(/[^0-9A-F]/g, "")
        while (inputstr.length > 0 && inputstr.substring(0, 1) === "0") {
            inputstr = inputstr.slice(1)
        }
        if (inputstr.length === 0) {
            inputstr = "0"
        }
        inputstr = "0x" + inputstr
        inputstr = inputstr.substring(0, 10) // cut off too many characters
        const old_input = [...currentSeed]
        old_input[idx] = inputstr
        setCurrentSeed(old_input)
    }

    const checkStartFrameHandler = event => {
        let inputstr = event.target.value
        inputstr = inputstr.replace(/[^0-9]/g, "")
        while (inputstr.length > 0 && inputstr.substring(0, 1) === "0") {
            inputstr = inputstr.slice(1)
        }
        if (inputstr.length === 0 || inputstr === "0") {
            inputstr = "1"
        }

        inputstr = inputstr.substring(0, 5) // cut off too many characters
        setCurrentStartFrame(inputstr)
    }

    const checkNumberOfFrameHandler = event => {
        let inputstr = event.target.value
        inputstr = inputstr.replace(/[^0-9]/g, "")
        while (inputstr.length > 0 && inputstr.substring(0, 1) === "0") {
            inputstr = inputstr.slice(1)
        }
        if (inputstr.length === 0 || inputstr === "0") {
            inputstr = "1"
        }
        inputstr = inputstr.substring(0, 5) // cut off too many characters
        setCurrentNumberOfFrames(inputstr)
    }

    const updateSeedHandler = (newSeed, storeRes) => {
        if (storeRes) {
            const rng = new XORSHIFT128(newSeed.StartSeed[0], newSeed.StartSeed[1], newSeed.StartSeed[2], newSeed.StartSeed[3])
            const tmp_profile = new TempProfile(userData, profile)
            for (let results = 0; results < newSeed.Idx; results++) {
                evaluate_result(rng, tmp_profile)
            }
            const original = tmp_profile.update_userdata()
            const ns = rng.get_raw_state()
            original.CloudRandomSet.Map[props.localKey].Context1 = parseInt(ns[0])
            original.CloudRandomSet.Map[props.localKey].Context2 = parseInt(ns[1])
            original.CloudRandomSet.Map[props.localKey].Context3 = parseInt(ns[2])
            original.CloudRandomSet.Map[props.localKey].Context4 = parseInt(ns[3])
            setUserData(original)
            setProfileData(tmp_profile.profile)
            setChanged(e => !e)
            setDisplayResults([])
            setCurrentSeed(rng.get_state())
        }
    }

    const get_current_lotdata = season => {
        let lotdata = LotReward[0]
        for (let elem of LotReward) {
            if (elem.Season <= season) {
                lotdata = elem
            }
        }
        return lotdata
    }

    const get_res = rng_res => {
        const lotdata = get_current_lotdata(CURRENT_SEASON)
        const LotInfo = lotdata.Info
        let val = 0.0
        let i = -1
        while (val <= rng_res) {
            i += 1
            val += LotInfo[i].Percent
        }
        return LotInfo[i]
    }

    const evaluate_result = (rng, tmp_profile) => {
        const res = get_res(rng.get_rand_float(0.0, 100.0))
        if (res.SubType === "Limited") {
            if (accuracyMode) {
                const limited_items = missing_season_items(res.Type, tmp_profile.profile)
                if (limited_items.length === 0) {
                    const res_tmp = { ...get_current_lotdata(CURRENT_SEASON).Info[res.SubstituteArrayId] }
                    res_tmp.Override = true
                    res_tmp.Original = res
                    return res_tmp
                } else {
                    rng.get_u32()
                    res.ElemId = limited_items[rng.get_u32() % limited_items.length]
                    if (res.Type === "NamePlateBg") {
                        add_nameplate([res.ElemId], tmp_profile.profile, e => tmp_profile.set_profile(e))
                    }
                    if (res.Type === "Byname") {
                        add_byname([res.ElemId], [res.ElemId], tmp_profile.profile, e => tmp_profile.set_profile(e))
                    }
                    return res
                }
            } else {
                rng.get_u32()
                res.Season = rng.get_u32()
                return res
            }
        }
        if (res.Type === "NamePlateBg" && accuracyMode) {
            res.ElemRaw = tmp_profile.nameplaterng.singlePull()
            add_nameplate([res.ElemRaw.Id], tmp_profile.profile, e => tmp_profile.set_profile(e))
        }
        if (res.Type === "Byname" && accuracyMode) {
            res.ElemRaw = tmp_profile.bynamerng.singlePull()
            add_byname([res.ElemRaw[0]], [res.ElemRaw[1]], tmp_profile.profile, e => tmp_profile.set_profile(e))
        }
        if (res.Type === "FoodTicket") {
            rng.get_u32()
            return res
        }
        if (res.Type === "GearSkillChip" || res.Type === "DrinkTicket") {
            const ability = (rng.get_u32() >>> 0) % 14
            res.Ability = ability
            return res
        }
        return res
    }

    const format_result = entry => {
        let desc = ""
        if (entry.Type === "MiniGameCardPack") {
            desc = <img src={"https://leanny.github.io/splat3/images/catalog/IconCardPack_00.png"} alt={entry.Type} />
        }
        if (entry.Type === "FoodTicket") {
            if (entry.SubType === "Food50") {
                desc = <img src={"https://leanny.github.io/splat3/images/food/IconShopFoodRank.png"} alt={entry.Type} />
            }
            if (entry.SubType === "Food100") {
                desc = <img src={"https://leanny.github.io/splat3/images/food/IconShopFoodRankL.png"} alt={entry.Type} />
            }
            if (entry.SubType === "FoodParty") {
                desc = <img src={"https://leanny.github.io/splat3/images/food/IconShopParty_01.png"} alt={entry.Type} />
            }
        }
        if (entry.Type === "NamePlateBg") {
            if (accuracyMode) {
                desc = <NamePlateBG elem={entry.ElemRaw} formless={true} fullSize={true} />
            } else {
                desc = <img src={"https://leanny.github.io/splat3/images/catalog/IconNameplate_02.png"} alt={entry.Type} />
            }
        }
        if (entry.SubType === "Limited") {
            if (accuracyMode) {
                const e = getElemFromProp(entry)
                if (entry.Type === "NamePlateBg") {
                    desc = <NamePlateBG elem={e} formless={true} fullSize={true} />
                }
                if (entry.Type === "Byname") {
                    desc = (
                        <>
                            <BynameAdjectiveString num={e[0]} formless={true} />
                            <BynameSubjectString num={e[1]} formless={true} />
                        </>
                    )
                }
            } else {
                if (entry.Type === "NamePlateBg") {
                    desc = (
                        <img
                            src={"https://leanny.github.io/splat3/images/catalog/IconNameplate_02.png"}
                            alt={`Banner Season`}
                            className={classes.Limited}
                        />
                    )
                }
                if (entry.Type === "Byname") {
                    desc = (
                        <img
                            src={"https://leanny.github.io/splat3/images/catalog/IconNameplate_03.png"}
                            alt={`Title Season`}
                            className={classes.Limited}
                        />
                    )
                }
            }
        } else {
            if (entry.Type === "Emote") {
                desc = <img src={"https://leanny.github.io/splat3/images/emote/Win_Tricol.png"} alt={entry.Type} />
            }
            if (entry.Type === "Byname") {
                if (accuracyMode) {
                    desc = (
                        <>
                            <BynameAdjectiveString num={entry.ElemRaw[0]} formless={true} />
                            <BynameSubjectString num={entry.ElemRaw[1]} formless={true} />
                        </>
                    )
                } else {
                    desc = desc = <img src={"https://leanny.github.io/splat3/images/catalog/IconNameplate_03.png"} alt={entry.Type} />
                }
            }
        }
        if (entry.Type === "GearSkillChip") {
            desc = (
                <div className={classes.FlexElem}>
                    {t("translation:LayoutMsg.Cmn_Menu_00.T_Count_01")}{" "}
                    <img
                        src={`https://leanny.github.io/splat3/images/skill/${SkillIDsRev[entry.Ability]}.png`}
                        alt={entry.Type}
                        className={classes.Chunk}
                        height={64}
                    />{" "}
                    x {entry.SameNum}
                </div>
            )
        }
        if (entry.Type === "DrinkTicket") {
            desc = (
                <div className={classes.FlexElem}>
                    {t("other:Extra.Drink")}{" "}
                    <img
                        src={`https://leanny.github.io/splat3/images/skill/${SkillIDsRev[entry.Ability]}.png`}
                        alt={entry.Type}
                        className={classes.Chunk}
                        height={64}
                    />{" "}
                    x {entry.SameNum}
                </div>
            )
        }
        if (entry.Type === "LockerSticker") {
            desc = (
                <div className={classes.FlexElem}>
                    {entry.NotSameNum} x {t("translation:CommonMsg.Glossary.Sticker")}
                </div>
            )
        }
        if (entry.Type === "LockerFigure") {
            desc = (
                <div className={classes.FlexElem}>
                    {entry.NotSameNum} x {t("translation:CommonMsg.Glossary.Figure")}
                </div>
            )
        }
        if (entry.Type === "AllGearSkillChip") {
            desc = (
                <div className={classes.FlexElem}>
                    <span
                        className={entry.Override ? (entry.Original.Type === "NamePlateBg" ? classes.Limited : classes.SubLimited) : null}
                    >
                        {t("translation:LayoutMsg.Cmn_Menu_00.T_Count_01")} x {entry.SameNum}
                    </span>
                </div>
            )
        }
        return (
            <div className={classes.ImgRes}>
                <center>{desc}</center>
            </div>
        )
    }

    const format_state = state => {
        return (
            <>
                {state[0]} | {state[1]} | {state[2]} | {state[3]}
            </>
        )
    }

    const is_shown = elem => {
        if (selectedResultTypes.length === 0) return true
        if (elem.Override) {
            elem = elem.Original
        }
        if (elem.SubType === "Limited") {
            if (elem.Type === "NamePlateBg") {
                for (const value of selectedResultTypes) {
                    if (value.value === "LimitedNamePlateBg") {
                        return true
                    }
                }
            } else if (elem.Type === "Byname") {
                for (const value of selectedResultTypes) {
                    if (value.value === "LimitedByname") {
                        return true
                    }
                }
            }
        } else {
            for (const value of selectedResultTypes) {
                if (value.value === elem.Type || (elem.SubType !== "None" && value.value === elem.SubType)) {
                    return true
                }
            }
        }

        return false
    }

    const calculateResultHandler = () => {
        const rng = new XORSHIFT128(currentSeed[0], currentSeed[1], currentSeed[2], currentSeed[3])
        const res = []
        let i = 0
        const startFrame = parseInt(currentStartFrame) - 1
        const maxFrames = parseInt(currentNumberOfFrames)

        const tmp_profile = new TempProfile(userData, profile)

        for (i = 0; i < startFrame; i++) {
            evaluate_result(rng, tmp_profile)
        }
        for (let results = 0, i = 0; results < maxFrames; i++) {
            const tmp = evaluate_result(rng, tmp_profile)
            if (is_shown(tmp)) {
                res.push({
                    Idx: startFrame + i + 1,
                    Result: format_result(tmp),
                    Grade: format_grade(tmp),
                    Raw: tmp,
                    Seed: format_state(rng.get_state()),
                    RawSeed: rng.get_state(),
                    Update: true,
                    StartSeed: currentSeed,
                })
                results = results + 1
            }
        }
        setDisplayResults(res)
    }

    const seed_fits = (current_state, entries, tmp_profile) => {
        for (var entry of entries) {
            const r = evaluate_result(current_state, tmp_profile)
            if (r.Type !== entry.Value.original.Type || r.SubType !== entry.Value.original.SubType) {
                return false
            }
        }
        return true
    }

    const estimate_pulls = useCallback(() => {
        return Math.floor((new Date() - new Date(2022, 8, 1)) / (24 * 3600 * 1000)) * 33 + 20
    }, [])

    const find_seed = entries => {
        const initial_seed = new XORSHIFT128(`${decrypted_key()}_${props.localKey}`)
        const potential_seeds = []
        for (var i = 0; i < estimate_pulls(); i++) {
            const tmp_profile = new TempProfile(userData, profile)
            const current_state = initial_seed.get_clone()
            if (seed_fits(current_state, entries, tmp_profile)) {
                potential_seeds.push(current_state.get_clone())
            }
            initial_seed.get_u32()
        }
        setPossibleResults(potential_seeds)
    }

    const store_seed_from_finding = () => {
        if (possibleResults.length === 1) {
            const original = { ...userData }
            const newSeed = possibleResults[0].get_raw_state()
            original.CloudRandomSet.Map[props.localKey].Context1 = newSeed[0]
            original.CloudRandomSet.Map[props.localKey].Context2 = newSeed[1]
            original.CloudRandomSet.Map[props.localKey].Context3 = newSeed[2]
            original.CloudRandomSet.Map[props.localKey].Context4 = newSeed[3]
            setUserData(original)
            setCurrentSeed(possibleResults[0].get_state())
        }
    }

    const resetSeed = useCallback(() => {
        if (!window.confirm(t("misc:Common.DeleteConfirmation"))) return

        const original = { ...userData }
        original.CloudRandomSet.Map[props.localKey].Context1 = 0
        original.CloudRandomSet.Map[props.localKey].Context2 = 0
        original.CloudRandomSet.Map[props.localKey].Context3 = 0
        original.CloudRandomSet.Map[props.localKey].Context4 = 0
        setUserData(original)
    }, [userData, t, setUserData, props.localKey])

    if (!initialised) {
        return (
            <>
                <GachaInit />
                <ControlInit findSeed={find_seed} localKey={props.localKey} />
                <ResultInit possibleResults={possibleResults} storeRes={store_seed_from_finding} />
            </>
        )
    }

    return (
        <>
            <Control
                seedValidator={checkSeedHandler}
                currentSeed={currentSeed}
                currentStartFrame={currentStartFrame}
                currentNumberOfFrames={currentNumberOfFrames}
                startValidator={checkStartFrameHandler}
                numberValidator={checkNumberOfFrameHandler}
                calculateResults={calculateResultHandler}
                handleResultTypes={handleResultTypes}
                selectedResultTypes={selectedResultTypes}
                resetSeed={resetSeed}
                hasAccuracyMode={is_setup_accuracy_mode()}
                accuracyMode={accuracyMode}
                setAccuracyMode={setAccuracyMode}
            />
            <ResultSet key={changed} results={displayResults} updateSeed={updateSeedHandler} />
        </>
    )
}

export default Gacha
